import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFashionProducts, getProductsOnCategory, getToysProducts } from "../../redux/Slices/ProductSlice";
import { useNavigate } from "react-router-dom";

const UseViewHomeProducts = () => {
  const dispatch = useDispatch();
  const [fashionLoading, setfashionLoading] = useState(true)
  const [fashionproducts, setFashionsproducts] = useState([]);
  const [toysLoading, settoysLoading] = useState(true)
  const [toysroducts, settoysproducts] = useState([]);
  const { FashionProduct, ToysProduct, ProductsOnCategoryList } = useSelector((state) => state.ProductReducer);


  // run the fashion products
  useEffect(() => {
    const run = async () => {
      setfashionLoading(true)
      await dispatch(getFashionProducts("657028bbe68d4f75f5b372a5"))
      setfashionLoading(false)
    }
    run();
  }, [])

  // run the toys products
  useEffect(() => {
    const run = async () => {
      settoysLoading(true)
      await dispatch(getToysProducts("65b4f7e99e0d90716a2f0193"))
      settoysLoading(false)
    }
    run();
  }, [])

  // handle getProductsOnCategory request response
  useEffect(() => {
    if (!fashionLoading && FashionProduct.data) {
      setFashionsproducts(FashionProduct.data.data);
    }else{
    }
  }, [fashionLoading]);

  // handle getProductsOnCategory request response
  useEffect(() => {
    if (!toysLoading && ToysProduct.data) {
      settoysproducts(ToysProduct.data.data);
    }
  }, [toysLoading]);

  return [fashionproducts, toysroducts];
};
export default UseViewHomeProducts;
